import { cn } from "@base/lib/utils";
import { useMergedDraftList } from "@features/draft/model/useMergedDraftList";
import { ChevronDown } from "lucide-react";
import { useId, useState } from "react";
import { DraftDocumentListItem } from "./DraftDocumentListItem";

/**
 * 초안은 검색 조건과 무관하게 접근할 수 있는 별도 펼침 영역이다. 검색 결과 건수에 포함하지 않는다.
 */
export function DailyLogSearchDrafts({ projectId }: { projectId: number }) {
  const drafts = useMergedDraftList(projectId);
  const [isExpanded, setIsExpanded] = useState(true);
  const listId = useId();

  if (drafts.length === 0) return null;

  return (
    <section className="py-2 border-b border-gray-200">
      <button
        type="button"
        className="flex justify-between items-center pb-2 w-full text-label2 text-gray-1000 md:text-gray-800"
        aria-expanded={isExpanded}
        aria-controls={listId}
        onClick={() => setIsExpanded((prev) => !prev)}
      >
        {`My drafts (${drafts.length})`}
        <ChevronDown
          width={16}
          height={16}
          aria-hidden="true"
          className={isExpanded ? "rotate-180 transition-transform" : "transition-transform"}
        />
      </button>
      <ul
        id={listId}
        hidden={!isExpanded}
        className={cn("flex flex-col gap-2 md:gap-0 md:divide-y md:divide-gray-100", !isExpanded && "hidden")}
      >
        {drafts.map((draft) => (
          <DraftDocumentListItem
            key={draft.draft_id}
            projectId={projectId}
            draftId={draft.draft_id}
            title={draft.title}
            updatedAt={draft.updated_at}
          />
        ))}
      </ul>
    </section>
  );
}
